import React from 'react'

import PerfectScrollbar from 'react-perfect-scrollbar'

import { Paper, Box, Typography, Divider, Switch } from '@material-ui/core'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'
import * as service from 'service'
import helpers from 'helpers'
import useFetch from 'hooks/useFetch'
import useConfirmDialog from 'hooks/useConfirmDialog'

const ContractsEditTaxes = ({ contract }) => {
  const confirmDialog = useConfirmDialog()
  const { response } = useFetch(service.recurrence.taxes.get, {})
  const [taxes, setTaxes] = React.useState()
  const [contractTaxes, setContractTaxes] = React.useState([])

  React.useEffect(() => {
    if (!response || !contract) {
      return
    }

    const taxes = helpers.contractTaxes.filterContractTaxes(
      response.data.taxes,
      contract.contractTaxes,
    )

    setTaxes(taxes)
    setContractTaxes(contract.contractTaxes)
  }, [response, contract])

  const handleChangeTax = async (event, tax) => {
    if (event.target.checked) {
      confirmDialog.open({
        visible: false,
        title: 'Ativar imposto',
        confirmButton: 'Ativar',
        message: 'Deseja realmente ativar este imposto?',
        handleConfirm: () => addContractTax(tax),
      })

      return
    }

    confirmDialog.open({
      visible: false,
      title: 'Inativar imposto',
      confirmButton: 'Inativar',
      message: 'Deseja realmente inativar este imposto?',
      handleConfirm: () => removeContractTax(tax),
    })
  }

  const addContractTax = async tax => {
    const response = await service.recurrence.contractTaxes.create({
      contractId: contract.id,
      taxId: tax.id,
    })

    const contractHasInactiveTax = !!contractTaxes.find(
      contractTax => contractTax.taxId === tax.id,
    )

    if (contractHasInactiveTax) {
      setContractTaxes(contractTaxes =>
        contractTaxes.map(contractTax => {
          if (contractTax.taxId !== tax.id) {
            return contractTax
          }

          return { ...contractTax, active: true }
        }),
      )
      return
    }

    setContractTaxes(contractTaxes => [
      ...contractTaxes,
      response.data.contractTax,
    ])
  }

  const removeContractTax = async tax => {
    const contractTax = contractTaxes.find(
      contractTax => contractTax.taxId === tax.id,
    )

    await service.recurrence.contractTaxes.destroy({
      contractId: contract.id,
      contractTaxId: contractTax.id,
    })

    setContractTaxes(contractTaxes =>
      contractTaxes.map(contractTax => {
        if (contractTax.taxId !== tax.id) {
          return contractTax
        }

        return { ...contractTax, active: false }
      }),
    )

    if (!tax.active) {
      setTaxes(taxes => taxes.filter(currentTax => currentTax.id !== tax.id))
    }
  }

  const taxChecked = taxId =>
    contractTaxes.some(
      checkedTax => checkedTax.taxId === taxId && checkedTax.active,
    )

  return (
    <Paper>
      <Box p={2}>
        <Typography variant="h4">Impostos vinculados à assinatura</Typography>
      </Box>

      <Divider />

      <PerfectScrollbar>
        <Table emptyMessage="Não há impostos configurados ou ativos" noWrap>
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell>Valor</TableCell>
              <TableCell>Escopo</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {taxes
              ? taxes.map(tax => (
                  <TableRow key={tax.id}>
                    <TableCell>{tax.name}</TableCell>
                    <TableCell>{tax.value}%</TableCell>
                    <TableCell>{tax.scope}</TableCell>
                    <TableCell align="right">
                      <Switch
                        onChange={event => handleChangeTax(event, tax)}
                        size="small"
                        checked={taxChecked(tax.id)}
                      />
                    </TableCell>
                  </TableRow>
                ))
              : null}
          </TableBody>
        </Table>
      </PerfectScrollbar>
    </Paper>
  )
}

export default ContractsEditTaxes
